import { PropertyAttributes } from '../../Interface/Response/Interest/PropertyAttributes';
import { ValueType } from '../../Enum/ProductProperties/ValueType';
import { Value } from '../../Enum/ProductProperties/Value';

const formatPercentage = (percentage: string): number => {
    if (!percentage.includes('%')) {
        return parseFloat(percentage);
    }

    return parseFloat(percentage.split('%')[0]);
}

export const formatBoolean = (booleanValue: string): string => {
    switch (booleanValue) {
        case Value.Yes:
            return 'Ja';
        case Value.Propose:
            return 'Op voorwaarde';
        case Value.INAPPLICABLE:
            return 'N.v.t.';
        default:
            return 'Nee';
    }
};

export const getSortableValue = (property: PropertyAttributes): string | number => {
    if (property.infoExpanded && property.info !== undefined) {
        return property.info;
    }

    if ([ValueType.INAPPLICABLE, ValueType.UNKNOWN].includes(property.type)) {
        return property.value;
    }

    if (property.type === ValueType.PERCENTAGE) {
        return formatPercentage(property.value);
    }

    if (property.type === ValueType.BOOLEAN || property.type === ValueType.PROPOSE) {
        return formatBoolean(property.value);
    }

    return property.value;
}


const index = {
    [ValueType.AMOUNT]: 0,
    [ValueType.ABSOLUTE_VALUE]: 1,
    [ValueType.PERCENTAGE]: 2,
    [ValueType.BOOLEAN]: undefined,
    [ValueType.PROPOSE]: undefined,
    [ValueType.HOURS]: undefined,
    [ValueType.INAPPLICABLE]: undefined,
    [ValueType.MONTH]: undefined,
    [ValueType.MONTHS]: undefined,
    [ValueType.UNKNOWN]: undefined,
};

export const getSortableIndex = (property: PropertyAttributes): number | undefined => index[property.type];
